export default "__VITE_ASSET__VEqOsBdp__"